import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    position: relative;
    gap: ${({ theme }) => theme.spacing[4]};

    @media (max-width: 768px) {
        flex-direction: column;
    }

    .area-display {
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.spacing[2]};
        margin: ${({ theme }) => theme.spacing[4]} 0;

        span {
            color: ${({ theme }) => theme.colors.gray700};
        }

        strong {
            color: ${({ theme }) => theme.colors.secondary600};
            font-size: ${({ theme }) => theme.fontSizes[3]};
        }
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        margin-top: ${({ theme }) => theme.spacing[4]};
    }

    .map-container {
        flex: 3;
        position: relative;
        min-height: 500px;
        border-radius: ${({ theme }) => theme.borderRadius.default};
        overflow: hidden;
    }

    .map-instructions {
        position: absolute;
        bottom: ${({ theme }) => theme.spacing[2]};
        left: ${({ theme }) => theme.spacing[2]};
        z-index: 1000;
        background-color: ${({ theme }) => theme.colors.gray000};
        padding: ${({ theme }) => theme.spacing[2]};
        border-radius: ${({ theme }) => theme.borderRadius.default};
        box-shadow: 0 0 10px ${({ theme }) => theme.colors.shadow.small};
        color: ${({ theme }) => theme.colors.gray700};
    }

    .history-undo-button,
    .location-button,
    .delete-button {
    }

    .history-undo-button {
        bottom: ${({ theme }) => theme.spacing[4]};
        left: ${({ theme }) => theme.spacing[4]};
    }

    .location-button {
        bottom: ${({ theme }) => theme.spacing[4]};
        left: ${({ theme }) => theme.spacing[12]};
    }

    .delete-button {
        bottom: ${({ theme }) => theme.spacing[4]};
        right: ${({ theme }) => theme.spacing[4]};
    }

    .field-marker {
        background-color: #1f4c2a !important;
        border-radius: 50% !important;
        border: 2px solid white !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        .marker-content {
            color: white;
            font-weight: bold;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
        }

        &.selected {
            background-color: #bcb61e !important;
            transform: scale(1.2);
            z-index: 1000;
        }
    }

    .field-pseudo-marker {
        width: 20px !important;
        height: 20px !important;
        background-color: ${({ theme }) => theme.colors.secondary600};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid white;
        cursor: pointer;
        opacity: 0.6;

        &:hover {
            opacity: 1;
        }

        .pseudo-marker-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            color: white;
            font-weight: bold;
        }
    }

    .custom-field-marker {
        .marker-container {
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
        }

        .marker-number {
            position: absolute;
            top: 5px;
            font-size: 12px;
            font-weight: bold;
            color: white;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        &.selected {
            .marker-container {
                transform: scale(1.2);
            }
        }
    }
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[6]};

    flex: 1;
    padding: ${({ theme }) => theme.spacing[4]};
    background-color: ${({ theme }) => theme.colors.gray000};
    border-radius: ${({ theme }) => theme.borderRadius.default};
    box-shadow: 0 0 0.625rem ${({ theme }) => theme.colors.shadow.small};

    @media (min-width: 769px) {
        max-width: 25%;
    }

    @media (max-width: 768px) {
        margin-bottom: ${({ theme }) => theme.spacing[4]};
    }
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
    align-items: center;
    justify-content: center;

    position: absolute;
    bottom: ${({ theme }) => theme.spacing[4]};
    right: ${({ theme }) => theme.spacing[4]};

    z-index: 1000;
`;

export const ZoomButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};

    position: absolute;
    top: ${({ theme }) => theme.spacing[4]};
    left: ${({ theme }) => theme.spacing[4]};

    z-index: 1000;
`;

export const ActionButtons = styled.button`
    width: 40px;
    height: 40px;

    background-color: ${({ theme }) => theme.colors.gray000};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.shadow.small};
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gray800};
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.gray200};
    }
`;
